'use client'

import classNames from 'classnames'
import React from 'react'

import { ReactComponent as ArrowIcon } from '~/assets/icons/arrow-menu.svg'
import { ReactComponent as BlankIcon } from '~/assets/icons/link-blank.svg'
import Link from '~/components/link'
import DashedDivider from '~/layouts/shared/dashed-divider'
import { IStrapiCommomLink } from '~/types/strapi'

interface Properties {
  active: boolean
  onClose: () => void
  onBack: () => void
  title: string
  itens: IStrapiCommomLink[]
}

const MobileSubMenu: React.FC<Properties> = ({
  active,
  title,
  itens,
  onBack,
  onClose,
}) => {
  return (
    <div
      className={classNames(
        'fixed z-50 top-0 left-0 bg-wine-1000 overflow-y-auto w-full h-full transition-transform duration-300 ease-out',
        {
          'translate-x-[110%] pointer-events-none': !active,
        }
      )}
    >
      <button
        className="absolute top-[1.375rem] text-neutral-white left-2 flex items-center justify-between text-lg text-left "
        type="button"
        onClick={() => onBack()}
      >
        <ArrowIcon className="rotate-90 w-5 h-5" width={20} height={20} />
        <p className="ml-2 text-base font-sans-16">Voltar</p>
      </button>
      <div className="pt-[4.375rem] flex flex-col">
        <DashedDivider className="text-neutral-white" />
        <div className="relative container pt-4 px-8 flex flex-col items-start">
          <h3 className="text-3xl font-sans-12 uppercase text-neutral-white">
            {title}
          </h3>
          <div className="mt-4 pl-2 flex flex-col gap-4">
            {itens.map((subNavItem) => (
              <Link
                key={`mobile-header-submenu-${subNavItem.id}`}
                href={subNavItem.url}
                blank={subNavItem.blank}
                className="menu-link submenu-link flex py-2 text-neutral-white items-center w-full text-base uppercase hover:text-red-600"
                onClick={onClose}
              >
                {subNavItem.name}
                {subNavItem.blank && (
                  <BlankIcon
                    className="ml-2 relative -top-[2px]"
                    width={13}
                    height={13}
                  />
                )}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileSubMenu
